import { TreeNode } from '@prismamedia/one-components';
import { GetNewslettersQuery_newsletters_Newsletter } from '__generated__/queries-newsletter';

export const getTemplatesTree = (
  templates: GetNewslettersQuery_newsletters_Newsletter[] | undefined = [],
) =>
  templates.reduce((acc: TreeNode[], { brandKey, id, name }) => {
    const dupplicateBrandKeyIndex = acc.findIndex(
      (item) => item.label === brandKey,
    );
    const newItem = { id, label: name };

    if (dupplicateBrandKeyIndex === -1) {
      // eslint-disable-next-line no-param-reassign
      acc = [
        ...acc,
        {
          id: brandKey,
          label: brandKey,
          children: [newItem],
        },
      ];
    } else {
      // eslint-disable-next-line immutable/no-mutation
      acc[dupplicateBrandKeyIndex] = {
        ...acc[dupplicateBrandKeyIndex],
        children: [
          ...(acc[dupplicateBrandKeyIndex].children as TreeNode[]),
          newItem,
        ],
      };
    }

    return acc;
  }, []);
